
import React from 'react';

const ValueStatementSection = () => {
  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="container px-4 sm:px-6 md:px-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-left mb-8 text-joerg-800">Warum Pakete hilfreich sein können</h2>
          
          <div className="prose prose-lg text-joerg-600 max-w-none">
            <p className="text-left mb-6">Manche Themen brauchen <span className="font-medium text-joerg-700">Raum, Reflexion oder Struktur</span>.</p>
            <p className="text-left mb-6">Andere lassen sich gut mit einem <span className="font-medium text-joerg-700">flexiblen Impuls</span> anstoßen.</p>
            <p className="text-left mb-6">Die Pakete geben dir eine <span className="font-medium text-joerg-700">Orientierung</span> – die Entscheidung treffen wir gemeinsam.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueStatementSection;
